<div class="one" [formGroup]="SettingForm" fxLayout="column" style="min-height: 200px">
  <div class="pb-20">
    <button matButton="filled" class="btn_2">
      <a
        href="https://community.silq.com.au/en/xero-integration"
        target="_blank"
        rel="noopener noreferrer"
        style="color: white"
      >
        Open Knowledge Base for more information on configuring your Xero integration.
      </a>
    </button>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" class="xero-disp mb-4">
    <mat-form-field
      appearance="outline"
      class="xero-imput shrink-0 pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.XEROINVOICEACCOUNT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.XEROINVOICEACCOUNT),
      }"
    >
      <mat-label>Xero Invoice Account</mat-label>
      <input class="sideText text-right" matInput formControlName="XEROINVOICEACCOUNT" />
    </mat-form-field>
    <div class="Bold_panel_header header-title text-[14px]">
      This is the default income account for invoices. "200" is the default income account in Xero,
      but you will need to change this if you have changed the account number in Xero.
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" class="xero-disp">
    <mat-form-field
      appearance="outline"
      class="xero-imput shrink-0 pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.XeroStartDate),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.XeroStartDate),
      }"
    >
      <mat-label>Xero Start Date</mat-label>
      <input
        (dateInput)="chooseXeroDate('input', $event)"
        (dateChange)="chooseXeroDate('change', $event)"
        formControlName="XEROSTARTTEXTDATE"
        matInput
        name="XeroStartDate"
        [matDatepicker]="picker1"
        placeholder="Xero Start Date"
      />
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
    </mat-form-field>
    <div class="Bold_panel_header header-title text-[14px]">
      When Syncing to Xero for the first time you can set a start date for the data that will be
      sent to Xero. If nothing is entered then on the first sync, it will only send data from after
      the current date.
    </div>
  </div>
  <div fxLayout="row wrap" fxLayoutAlign="start center" class="checkbox-disp">
    <div class="xero-imput">
      <mat-checkbox formControlName="XERODONTSYNCINVOICES">
        Don't Sync Invoices/Receipts
      </mat-checkbox>
    </div>
    <div class="xero-imput-1">
      <mat-checkbox formControlName="XERODONTSYNCEXPENSES">Don't Sync Expenses</mat-checkbox>
    </div>
  </div>
  @if (SettingForm.value['XEROORGANISATION']) {
    <div fxLayout="row wrap" fxLayoutAlign="start center" class="checkbox-disp">
      <div class="xero-input-2 text-[14px]">
        Linked Organisation: &nbsp;&nbsp;
        <strong>{{ SettingForm.value['XEROORGANISATION'] }}</strong>
      </div>
    </div>
  }
  <br />
  <!-- *ngIf="!SettingForm.value['XEROORGANISATION']" -->
  @if (!SettingForm.value['XEROORGANISATION']) {
    <div fxLayout="row wrap" fxLayoutAlign="start" class="checkbox-disp">
      <div class="xero-input-3">Linked Organisation: &nbsp;&nbsp;</div>
      <div class="xero-imput-4">
        <div>
          <!-- <button mat-raised-button color="accent" class="btn_2"
            [routerLink]="'/my-profile/connections'">Connect to Xero</button>&nbsp;&nbsp;<strong>Go
            to your connections to establish a connection by
          authenticating with Xero.</strong> -->
          <button matButton="filled" class="btn_2" (click)="ConnectToXero()">
            Connect to Xero
          </button>
          &nbsp;&nbsp;
          <strong>
            Go to your connections to establish a connection by authenticating with Xero.
          </strong>
        </div>
        <br />
        <div>
          <button matButton="filled" class="btn_2" (click)="loadOrg()">Load Organisations</button>
          &nbsp;&nbsp;
          <strong>
            Once you have successfully connected to Xero click this button to load the organisations
            associated with your Xero account.
          </strong>
        </div>
        <br />
        <div>
          <!-- *ngIf="NETACCOUNTS.length > 0" -->
          <mat-form-field appearance="outline" class="xero-imput-5 pr-1">
            <mat-label>Select Xero Organisation</mat-label>
            <mat-select
              [(ngModel)]="tenantName"
              [ngModelOptions]="{ standalone: true }"
              (selectionChange)="changeTenant($event)"
            >
              @for (na of NETACCOUNTS; track na) {
                <mat-option value="{{ na.TENANTID }}">
                  {{ na.TENANTNAME }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          &nbsp;&nbsp;
          <strong>Select the organisation you want your SILQ data file to be linked to.</strong>
        </div>
        <br />
        <div>
          <button matButton="filled" class="btn_2" (click)="linkOrg()">Link Organisation</button>
          &nbsp;&nbsp;
          <strong>
            Click Link Organisation to connect this SILQ data file with the Xero organisation. Once
            you have linked as organisation it cannot be unlinked.
          </strong>
        </div>
      </div>
    </div>
  }
  <div align="end">
    <mat-dialog-actions class="popup_ftr">
      @if (SettingForm.value['XEROORGANISATION']) {
        <button class="mr-10" matButton="filled" [disabled]="isLoading" (click)="disconnectXero()">
          @if (isLoading) {
            <mat-spinner diameter="24"></mat-spinner>
          }
          Disconnect Xero
        </button>
      }

      <button
        id="callApiId"
        class="mainbtn_size"
        matButton="filled"
        [disabled]="isspinerInfo"
        (click)="saveXero()"
      >
        @if (isspinerInfo) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Save
      </button>
      <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
    </mat-dialog-actions>
  </div>
  <!-- <mat-dialog-actions align="end" class="popup_ftr">
<button mat-raised-button color="accent" class="btn_2" (click)="testConnections()">
Connect</button>
</mat-dialog-actions> -->
</div>
